//React
import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";

//Libs
import { Button } from "semantic-ui-react";
import swal from "sweetalert";

//Services
import { producaov2 as api } from "../../../../services/apis";

//Components
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";

import Loading from "../../../../components/Loading";

//Styles
import { datePattern } from "../../../../utils/Utils";
import {
  Container, ContainerInputSearch, Content, Input,
  SemanticTable, Title
} from "./styles";

const ListarCampaign = () => {
  const [search, setSearch] = useState("");
  const [campaign, setCampaign] = useState([]);
  const [loading, setLoading] = useState(false);



  useEffect(() => {
    loadCampaign();
  }, []);

  const loadCampaign = useCallback(
    async () => {
      setLoading(true);

      try {

        const response = await api.get("admin/campaign");

        setCampaign(response.data);
        // await systemLogs(`/campaign`, `Listou a campanha`);
        setLoading(false);
      } catch (err) {
        swal(`Não foi possível carregar os cursos`, err, "error");
        setLoading(false);
      }
    },
    [search]
  );

  return (
    <Container>
      <AdminMenu />
      <Content>
        <Title>Campanhas</Title>
        <ContainerInputSearch>
          <Input
            type="text"
            placeholder="Pesquise pelo titulo"
            onChange={(e) => setSearch(e.target.value)}
          />
          <Link to="/admin/campaign/criar">
            <Button>Criar</Button>
          </Link>
        </ContainerInputSearch>

        <SemanticTable size="big" celled>
          <SemanticTable.Header>
            <SemanticTable.Row>
              <SemanticTable.HeaderCell> Id </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell> Titutlo </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell> Clicks </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell> Ativo </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Criada</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Ações</SemanticTable.HeaderCell>
            </SemanticTable.Row>
          </SemanticTable.Header>

          <SemanticTable.Body className="table-body">
            {loading ? (
              <Loading
                msg=
                  "Buscando campanhas..." 
                
              />
            ) : (
              campaign.map((elem) => (
                <SemanticTable.Row>
                  <SemanticTable.Cell>{elem.id}</SemanticTable.Cell>
                  <SemanticTable.Cell>{elem.title_campaign}</SemanticTable.Cell>
                  <SemanticTable.Cell>{elem.clicks}</SemanticTable.Cell>
                  <SemanticTable.Cell>{elem.active ? "Ativa" : "Desativada"}</SemanticTable.Cell>
                  <SemanticTable.Cell>{datePattern(elem.data_sys)}</SemanticTable.Cell>

                  <SemanticTable.Cell>
                    <>
                      <Button
                        icon="edit icon"
                        size="small"
                        color={"grey"}
                        onClick={() =>
                          window.open(`/admin/campaign/${elem.id}`)
                        }
                      />
                    </>
                  </SemanticTable.Cell>
                </SemanticTable.Row>
              ))
            )}
          </SemanticTable.Body>
        </SemanticTable>
      </Content>
    </Container>
  );
};

export default ListarCampaign;
